if (!customElements.get('gts-payments')) {
  customElements.define('gts-payments', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.dialog = this.querySelector('dialog');
      this.opener = this.querySelector('.gts-payments__open');
      this.format = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
      this.opener.onclick = () => this.dialog.showModal();
      this.querySelector('[data-close]').onclick = () => this.dialog.close();
      this.dialog.addEventListener('close', () => this.opener.focus());
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      this.querySelectorAll('[data-panel]').forEach(button => {
        button.onclick = () => {
          const card = button.dataset.panel === 'card';
          this.querySelector('[data-card-panel]').hidden = !card;
          this.querySelector('[data-pix-panel]').hidden = card;
          this.querySelectorAll('[data-panel]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        };
      });
      this.renderPrice(Number(this.dataset.price));
      this.priceBox = document.getElementById(`price-${this.dataset.section}`);
      this.observer = new MutationObserver(() => this.syncPrice());
      if (this.priceBox) this.observer.observe(this.priceBox, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
      this.syncPrice();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
    }
    syncPrice() {
      const node = this.priceBox?.querySelector('.price-regular .price');
      if (!node) return;
      const match = node.textContent.replace(/\s/g, '').match(/([\d.]+),(\d{2})/);
      if (!match) return;
      const price = Number(match[1].replace(/\./g, '')) * 100 + Number(match[2]);
      this.renderPrice(price);
    }
    renderPrice(price) {
      if (!Number.isSafeInteger(price) || price < 0 || price === this.lastPrice) return;
      this.lastPrice = price;
      const money = cents => this.format.format(cents / 100);
      this.querySelectorAll('[data-pix]').forEach(node => node.textContent = money(Math.round(price * 95 / 100)));
      this.querySelector('[data-three]').textContent = money(Math.round(price / 3));
      this.querySelectorAll('[data-count]').forEach(row => {
        const count = Number(row.dataset.count);
        const total = count <= 3 ? price : Math.round(price * (10000 + 189 * count) / 10000);
        row.querySelector('[data-installment]').textContent = money(Math.round(total / count));
        row.querySelector('[data-total]').textContent = money(total);
      });
    }
  });
}
